import { colonyAPI } from '@/api';
import { destructDate } from '@/helpers/date';

import * as types from './mutation-types';
import state from './state';

export default {
  getAllCharts() {
    this.$store.dispatch('analytics/getCharts');
    this.$store.dispatch('analytics/getMainChart');
  },

  getCharts({ commit }) {
    commit(types.GET_ANALYTICS_CHARTS_REQUEST);

    const data = {
      ...destructDate(state.selectedDate),
      unit: state.selectedPeriod,
      timeslot: state.selectedTimeslot,
    };

    colonyAPI
      .post('/analytics/engagements/', data)
      .then(response => commit(types.GET_ANALYTICS_CHARTS_SUCCESS, response))
      .catch(error => commit(types.GET_ANALYTICS_CHARTS_FAILURE, error));
  },

  getMainChart({ commit }) {
    commit(types.GET_ANALYTICS_MAIN_CHART_REQUEST);

    const data = {
      ...destructDate(state.selectedDate),
      unit: state.selectedPeriod,
      timeslot: state.selectedTimeslot,
      filtering: state.selectedFilter,
    };

    colonyAPI
      .post('/analytics/engagements/chart/', data)
      .then(response => commit(types.GET_ANALYTICS_MAIN_CHART_SUCCESS, response))
      .catch(error => commit(types.GET_ANALYTICS_MAIN_CHART_FAILURE, error));
  },

  getCampaignReport({ commit }, campaignId) {
    commit(types.GET_ANALYTICS_CAMPAIGN_REPORT_REQUEST);

    colonyAPI
      .get(`/analytics/engagements/campaign/${campaignId}/report/`)
      .then(response => commit(types.GET_ANALYTICS_CAMPAIGN_REPORT_SUCCESS, response))
      .catch(error => commit(types.GET_ANALYTICS_CAMPAIGN_REPORT_FAILURE, error));
  },

  getCampaignListSimpleCharts({ commit }, campaignIds) {
    commit(types.GET_ANALYTICS_CAMPAIGN_LIST_REQUEST);

    colonyAPI
      .post('/analytics/engagements/campaign/simple-list/', { campaign_ids: campaignIds })
      .then(response => commit(types.GET_ANALYTICS_CAMPAIGN_LIST_SUCCESS, response))
      .catch(error => commit(types.GET_ANALYTICS_CAMPAIGN_LIST_FAILURE, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/analytics/actions.js